<template>
    <div class="Recorder"></div>
</template>

<script>


export default {

    name: 'Recorder',
    data: () => ({ 

        recording: false 
    }),
    beforeDestroy() {
    },

    mounted() {

        this.$stream = this.$parent.$refs.canvas.captureStream(60)
        this.$recorder = new MediaRecorder(this.$stream)
        this.$data_record = []
    },

    methods: {

        handleDataAvailable(event) {
            if (event.data && event.data.size > 0) { this.$data_record.push(event.data) }
        },

        record() {

            this.recording = !this.recording
            if(this.recording) {

                console.log('recording');
                this.$recorder.ondataavailable = this.handleDataAvailable
                this.$recorder.start(100)

            } else {

                console.log('stop');

                this.$recorder.stop()
                var blob = new Blob(this.$data_record, { type: 'video/webm' })

                console.log(blob);

                var url = URL.createObjectURL(blob)
                var a = document.createElement('a')
                document.body.appendChild(a)
                    a.style = 'display: none'
                    a.href = url
                    a.download = 'test.webm'
                    a.click();
                window.URL.revokeObjectURL(url)
                // window.location.href = 'email'
            }

        },
    }
}
</script>















